export enum BrandedPlayButtonStatus {
  FREE_PLAY = 'freePlay',
  TICKET = 'ticket',
  NO_TICKET = 'noTicket',
  PURPLE = 'purple',
  GREEN = 'green',
  EDIT = 'edit',
}
